class HoculusPopup extends HTMLElement {
	constructor() {
		super();
		this.querySelector(".close-popup")?.addEventListener("click", () => this.closePopup());
		this.classList.add("hoculus-popup");
		this.addEventListener('click', (event) => event.target === event.currentTarget && this.closePopup());
	}

	closePopup() { this.classList.remove("is-open") };
	openPopup() { this.classList.add("is-open") };
}

if (!customElements.get('hoculus-popup')) {
	customElements.define("hoculus-popup", HoculusPopup);
}

if (!customElements.get('hoculus-popup-button')) {
	class HoculusPopupButton extends HTMLElement {
		constructor() {
			super();
			this.productForm = this.querySelector("product-form");
			this.messageDiv = this.querySelector(".error-message");
			this.button = this.querySelector("button");
		}

		connectedCallback() {
			this.productForm.addEventListener('on:cart:error', () => {
				this.onAddError();
			});
		}

		onAddError() {
			// Shows error message on top of button
			this.parentNode.classList.add("popup-card-error");
			this.messageDiv.classList.add('show-message');
			this.button.disabled = true;
        	this.button.setAttribute('aria-disabled', 'true');
			setTimeout(() => {
				this.parentNode.classList.remove("popup-card-error");
				this.messageDiv.classList.remove('show-message');
			}, 5000);
		}
	}
	customElements.define("hoculus-popup-button", HoculusPopupButton);
}

if (!customElements.get('hoculus-atc-popup')) {
	class HoculusAtcPopup extends HoculusPopup {
		constructor() {
			super();
			this.ctaArray = this.querySelectorAll("hoculus-isolated-add-to-cart");
			this.cartDrawer = document.querySelector("#cart-drawer");
			this.productForm = document.querySelector(this.dataset.formSelector);
		}

		connectedCallback() {
			if (this.productForm) {
				this.productForm.addEventListener('on:cart:add', () => {
					this.openPopupCallback();
				});

				this.productForm.addEventListener('on:line-item:change', () => {
					this.openPopupCallback();
				});
			}
		}

		openPopupCallback() {
			this.openPopup();
			// Hide the cart drawer with css to then show it after we close the popup
			this.cartDrawer.classList.add("opacity-0");
		}

		// Executed whenever the X icon is clicked
		closePopup() {
			this.classList.remove("is-open");
			this.cartDrawer.removeAttribute("open");

			// To trigger the animation we have to remove and add the "open" attribute, a setTimeout is necessary to properly show the animation
			setTimeout(() => {
				this.cartDrawer.classList.remove("opacity-0");
				this.cartDrawer.setAttribute("open", "");
			}, 100);
		};
	}
	customElements.define("hoculus-atc-popup", HoculusAtcPopup);
}